export default __webpack_public_path__ + "static/media/Jockey.73f6d403.jpeg";